module.exports = "https://bin.bnbstatic.com/_next/static/images/Paolo-fad1e24263fa3fc1cc7937b69db9ed6d.jpg";